import {toAbsoluteUrl} from '../../../helpers'

export function FallbackView() {
  return (
    <div className='splash-screen'>
      <img
        src={toAbsoluteUrl('/media/logos/CarWash.jpg')}
        alt='Start logo'
        className='h-500px'
      />
      <span>Loading ...</span>
    </div>
  )
}
